const Layout = r => require(['@/pages/PageLayout'], r)

// 工具箱
const Tool = r => require(['@/pages/tool/index'], r)

// 考务
const ToolExamTask = r => require(['@/pages/tool/examTask/index'], r)  // 考务介绍
const ToolExamTaskList = r => require(['@/pages/tool/examTask/list'], r)  // 考务列表
const ToolExamTaskCreateLayout = r => require(['@/pages/tool/examTask/createLayout'], r)  // 新增考务基础页
const ToolExamTaskCreateFirst = r => require(['@/pages/tool/examTask/create/first'], r)  // 新增考务第一步
const ToolExamTaskCreateSecond = r => require(['@/pages/tool/examTask/create/second'], r)  // 新增考务第二步
const ToolExamTaskCreateThird = r => require(['@/pages/tool/examTask/create/third'], r)  // 新增考务第三步
const ToolExamTaskLook = r => require(['@/pages/tool/examTask/look'], r)  // 查看考务

// 成绩单
const ToolExamSheet = r => require(['@/pages/tool/examSheet/intro'], r)  // 成绩单介绍
const ToolExamSheetList = r => require(['@/pages/tool/examSheet/list'], r)  // 成绩单介绍
const ToolExamNewSheet = r => require(['@/pages/tool/examSheet/toolExamNewSheet'], r)  // 新增成绩表
const ToolExamAddSubject = r => require(['@/pages/tool/examSheet/toolExamAddSubject'], r)  // 新增学科
const ToolExamSheetDetail = r => require(['@/pages/tool/examSheet/detail'], r)  // 成绩单查看
const ToolExamSheetResult = r => require(['@/pages/tool/examSheet/result'], r)  // 成绩单结果
const ToolExamSheetStudent = r => require(['@/pages/tool/examSheet/studentScore'], r)  // 学生历史成绩

//招生分班
const ToolClassAssign = r => require(['@/pages/tool/classAssign/intro'], r)  // 招生分班介绍
const ToolClassAssignList = r => require(['@/pages/tool/classAssign/list'], r)  // 招生分班列表
const ToolClassAssignCreate1 = r => require(['@/pages/tool/classAssign/create_step1'], r)  // 招生分班创建step1
const ToolClassAssignCreate2 = r => require(['@/pages/tool/classAssign/create_step2'], r)  // 招生分班创建step2
const ToolClassAssignRankDetail = r => require(['@/pages/tool/classAssign/rankDetail'], r)  // 招生分班分区详情
const ToolClassAssignClassDetail = r => require(['@/pages/tool/classAssign/classDetail'], r)  // 招生分班明细
const ToolClassAssignRecord = r => require(['@/pages/tool/classAssign/record'], r)  // 招生分班查看记录

// 答题卡
const answerSheet = r => require(['@/pages/tool/answerSheet/intro'], r)  // 答题卡模板介绍

const answerSheetList = r => require(['@/pages/tool/answerSheet/list'], r)  // 答题卡模板列表


export default {
  path: '/tool',
  component: Layout,
  redirect: '/tool/index',
  children: [
    {
      path: '/tool/index',
      component: Tool
    },

    // 成绩单
    {
      path: '/tool/sheet/intro',
      component: ToolExamSheet
    },
    {
      path: '/tool/sheet/list',
      component: ToolExamSheetList
    },
    {
      path: '/tool/sheet/newsheet',
      component: ToolExamNewSheet
    },
    {
      path: '/tool/sheet/addsubject',
      component: ToolExamAddSubject
    }, {
      path: '/tool/sheet/detail',
      component: ToolExamSheetDetail
    },
    {
      path: '/tool/sheet/result',
      component: ToolExamSheetResult
    },
    {
      path: '/tool/sheet/student',
      component: ToolExamSheetStudent
    },


    // 任务管理
    {
      path: '/tool/task/intro',
      component: ToolExamTask
    },
    {
      path: '/tool/task/list',
      component: ToolExamTaskList
    },
    {
      path: '/tool/task/list/:id/:gradeId',
      component: ToolExamTaskLook
    },
    {
      path: '/tool/task/create',
      component: ToolExamTaskCreateLayout,
      redirect: '/tool/task/create/first',
      children: [
        {
          path: '/tool/task/create/first',
          component: ToolExamTaskCreateFirst
        },
        {
          path: '/tool/task/create/second',
          component: ToolExamTaskCreateSecond
        },
        {
          path: '/tool/task/create/third',
          component: ToolExamTaskCreateThird
        },
      ]
    }, {
      path: '/tool/classAssign/intro',
      component: ToolClassAssign
    }, {
      path: '/tool/classAssign/list',
      component: ToolClassAssignList
    }, {
      path: '/tool/classAssign/create_step1',
      component: ToolClassAssignCreate1
    }, {
      path: '/tool/classAssign/create_step2',
      component: ToolClassAssignCreate2
    }, {
      path: '/tool/classAssign/rankDetail',
      component: ToolClassAssignRankDetail
    }, {
      path: '/tool/classAssign/classDetail',
      component: ToolClassAssignClassDetail
    }, {
      path: '/tool/classAssign/record',
      component: ToolClassAssignRecord
    }, {
      path: '/tool/answerSheet/intro',
      component: answerSheet
    }, {
      path: '/tool/answerSheet/list',
      name: 'sheet-list',
      component: answerSheetList,
      meta: {
        title: '答题卡制作',
        // url: '/v2/card/index'
      }
    }
  ]
}